// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1___040bd22bafdb1b22322","cls2":"AutoCompleteResultRow-cls2__d057ec5da7ede1083aa4 AutoCompleteResultRow-cls1___040bd22bafdb1b22322"};